import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {useDebounce, KTSVG} from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {
  // DeleteData,
  // GetFilterContactTag,
  UnassignetagsContacts,
  // getFilterContactTag,
} from './TagSlice/TagsSlices'
import {Select} from '@material-ui/core'

import {Dropdown} from 'react-bootstrap'

import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import NodataYet from '../../../../Components/NodataYet'
import {openPopup} from '../../../../Components/PopupSlice/popupSlice'
import {useContactByTag} from './useContactListByTagHooks'
import { getIsDefaultRegion } from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const ContactListByTag = () => {
  const param: any = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {getDataContact, tagsContact, dbOptions} = useContactByTag()
  const [isShowPaginate, setShowPaginate] = useState(true)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)

  const [createSegment, setCreateSegment] = useState(false)

  // const subscriberList = useSelector((state: any) => state?.subscriberData?.subscriberList?.data)
  // const dbOptions: any[] = useSelector(
  //   (state: any) => state?.subscriberData?.FieldName?.data?.fields
  // )
  //Delete All state
  const [val, setVal] = useState([])
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [quickMessage, setQuickmessage] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })

  useEffect(() => {
    if (tagsContact && tagsContact.totalPages === 0) {
      setShowPaginate(false)
    }
  }, [tagsContact])

  const debouncedSearchTerm = useDebounce(page?.search, 1000)

  useEffect(() => {
    dispatch(startLoadding())
    // const params = {
    //   id: groupid,
    //   page: { page: page.page, size: page.size, tagId: param?.state },
    // } as any
    // if (page?.search && page.search !== '') {
    //   params.page.search = page.search
    // }
    getDataContact(page, groupid, param?.state)
    // dispatch(GetFilterContactTag(params))
  }, [debouncedSearchTerm, page.page, page.size])
  ///////CUSTOM FUNCTION ///////////////////////////////////////////

  const checkField = () => {
    let fields = ['First Name', 'Full Name', 'Last Name']
    if (dbOptions?.find((val: any) => fields.includes(val)) == undefined) {
      return false
    } else {
      return true
    }
  }

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        UnassignetagsContacts({
          tagId: param?.state,
          contactIds: checkList,
        })
      )
      setConfirm(false)
      setCheckList([])
      navigate('/contacts/tags')
    }
  }, [confirm])

  const handleCheckAll = () => {
    if (checkList?.length == tagsContact?.items?.length) {
      setCheckList([])
    } else {
      let list = tagsContact?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }

  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const sendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={quickMessage}
        handleClose={() => setQuickmessage(false)}
        contacts={tagsContact?.items
          ?.filter((key: any) => checkList?.includes(key?._id))
          ?.map((key: any) => ({value: key?.number, label: key?.number}))}
      />
    ),
    [checkList, quickMessage]
  )

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete Tag?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  return (
    <>
      {confirmation}
      {AuthenticateUser('send-quick-sms') && quickMessage && sendQuickMessage}
      <div className='card mb-0'>
        <div className='card-header align-items-center border-bottom-0'>
          {/* ///////////////////////////////////// */}
          <div className='d-flex align-items-start position-relative my-1 flex-column flex-sm-row'>
            <div className='relative'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6 mt-3'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search user'
                onChange={(e: any) => setPage({...page, search: e.target.value})}
              />
            </div>
          </div>
          <div className='card-toolbar mt-0'>
            <div className='me-0'>
              <Dropdown>
                {(AuthenticateUser('send-quick-sms') || AuthenticateUser('tag-untag-contacts')) && (
                  <Dropdown.Toggle className='btn btn-primary my-2 m-sm-0 ms-sm-3'>
                    Action
                    <KTSVG
                      path='/media/icons/duotune/arrows/down-white.svg'
                      className='svg-icon-6 ms-3'
                    />
                  </Dropdown.Toggle>
                )}

                <Dropdown.Menu className='w-250px'>
                  {AuthenticateUser('send-quick-sms') && (
                    <Dropdown.Item
                      onClick={() => {
                        checkList?.length > 0
                          ? setQuickmessage(true)
                          : dispatch(openPopup('Atleast select one number to send quick message '))
                        // alert('Atleast select one number to send quick message ')
                      }}
                      className='menu-content   p-3 fs-8 text-uppercase'
                    >
                      Send quick message
                    </Dropdown.Item>
                  )}
                  {(AuthenticateUser('send-quick-sms') && isDefaultRegion) && (
                    <Dropdown.Item
                      onClick={() => {
                        if (checkList) {
                          if (checkList?.length > 0) {
                            navigate(`/new-message`, {
                              state: {
                                selectedType: 'contacts',
                                data: tagsContact?.items
                                  ?.filter((key: any) => checkList?.includes(key?._id))
                                  ?.map((key: any) => key?.number),
                              },
                            })
                          } else {
                            navigate(`/new-message`, {
                              state: {
                                selectedType: 'segmentOrTags',
                                data: `tag_${param?.state}`,
                              },
                            })
                          }
                        }
                      }}
                      className='menu-content  p-3 fs-8 text-uppercase'
                    >
                      Bulk Message
                    </Dropdown.Item>
                  )}

                  {/* <Dropdown.Item className='menu-content  p-3 fs-8 text-uppercase'>
                    Export as CSV
                  </Dropdown.Item>
                  <Dropdown.Item className='menu-content  p-3 fs-8 text-uppercase'>
                    Remove tag
                  </Dropdown.Item> */}
                  {AuthenticateUser('tag-untag-contacts') &&
                    Array.isArray(checkList) &&
                    checkList.length > 0 && (
                      <Dropdown.Item
                        onClick={() => setOpen(true)}
                        className='menu-content  p-3 fs-8 text-uppercase text-danger'
                      >
                        Delete tag
                      </Dropdown.Item>
                    )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        {tagsContact?.items?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='d-flex my-4'></div>
            {/* <button  className='btn btn-primary ' onClick={handleDeleteAll}>UNASSIGNED TAGS</button> */}
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th className='w-25px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value='ALL'
                            data-kt-check='true'
                            data-kt-check-target='.widget-9-check'
                            checked={checkList?.length >= tagsContact?.items?.length}
                            onChange={handleCheckAll}
                          />
                        </div>
                      </th>
                      <th>Mobile Number</th>
                      <th>Tags</th>

                      {checkField() && dbOptions?.includes('First Name') && <th>First Name</th>}
                      {checkField() && dbOptions?.includes('Last Name') && <th>Last Name</th>}
                      {checkField() && dbOptions?.includes('Full Name') && <th>Full Name</th>}
                      {dbOptions?.map((val: any, i: number) => {
                        if (!['First Name', 'Full Name', 'Last Name']?.includes(val)) {
                          return <th key={i}>{val}</th>
                        }
                      })}

                      <th>Date Added</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {tagsContact?.items?.map((val: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              value={val?._id}
                              checked={checkList?.includes(val?._id)}
                              onChange={handleCheck}
                            />
                          </div>
                        </td>
                        <td>{val?.number}</td>
                        <td
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title={val?.tags
                            ?.filter((data: any) => {
                              if (data?.type) {
                                return data?.isHidden !== true && data?.type !== 'list'
                              }
                              return data?.isHidden !== true
                            })
                            ?.map((data: any) => data?.name)
                            .join()}
                        >
                          <div className='d-flex gap-2 align-items-center flex-wrap '>
                            {val?.tags
                              ?.filter((data: any) => {
                                if (data?.type) {
                                  return data?.isHidden !== true && data?.type !== 'list'
                                }
                                return data?.isHidden !== true
                              })
                              ?.map(
                                (data: {_id: string; name: string; color: string}, i: number) => (
                                  <div
                                    key={i}
                                    className='inbox-tags'
                                    style={{
                                      color: data?.color ? 'white' : 'black',
                                      backgroundColor: data?.color ? data?.color : '',
                                    }}
                                  >
                                    {data?.name}
                                  </div>
                                )
                              )}
                          </div>
                        </td>
                        {dbOptions?.includes('First Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'First Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'First Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.includes('Last Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'Last Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'Last Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.includes('Full Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'Full Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'Full Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.map((Fields: any, i: number) => {
                          let check = val?.fields?.map((key: any) => key?.name)
                          if (!['First Name', 'Full Name', 'Last Name']?.includes(Fields)) {
                            if (check?.includes(Fields)) {
                              return (
                                <td key={i}>
                                  {val?.fields?.find((key: any) => key?.name == Fields)?.value}
                                </td>
                              )
                            } else {
                              return <td key={i}>--</td>
                            }
                          }
                        })}

                        <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <NodataYet />
        )}

        {isShowPaginate && (
          <div className='abcd ps-10 pe-5 pb-5'>
            <select
              onChange={(e: any) => setPage({...page, size: parseInt(e.target.value), page: 1})}
              defaultValue={page.page}
            >
              <option value={10} selected={page.size === 10}>
                10
              </option>
              <option value={20} selected={page.size === 20}>
                20
              </option>
              <option value={50} selected={page.size === 50}>
                50
              </option>
              <option value={100} selected={page.size === 100}>
                100
              </option>
              <option value={250} selected={page.size === 250}>
                250
              </option>
            </select>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={tagsContact?.totalPages}
              onPageChange={(e: any) => setPage({...page, page: parseInt(e.selected) + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default ContactListByTag
